var React = require('react');

function Function (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"st0","d":"M98.6,54H79.7c-0.6,0-1.1-0.3-1.4-0.9L51.5-3H40.1c-0.5,0-0.8-0.2-1.1-0.5c-0.3-0.3-0.5-0.6-0.5-1.1v-16.9\r\n\tc0-0.9,0.6-1.5,1.5-1.5h23.7c0.6,0,1.1,0.3,1.4,0.9l26.6,56h6.8c0.9,0,1.5,0.6,1.5,1.5v16.9C100.2,53.3,99.5,54,98.6,54z M80.6,50.9\r\n\th16.5V37h-6.2c-0.6,0-1.1-0.3-1.4-0.9l-26.6-56H41.7v13.9h10.8c0.6,0,1.1,0.3,1.4,0.9L80.6,50.9z","key":0}),React.createElement("path",{"className":"st0","d":"M47.8,54h-20c-0.5,0-1.1-0.3-1.2-0.8c-0.3-0.5-0.3-1.1,0-1.5L47.4,7.9C47.7,7.5,48.1,7,48.7,7s1.1,0.3,1.4,0.9\r\n\tl10,20.6c0.2,0.5,0.2,0.9,0,1.4L49.2,53C48.9,53.7,48.4,54,47.8,54z M30.3,50.9h16.6l10.2-21.6l-8.3-17.2L30.3,50.9z","key":1})]);
}

Function.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"24 -24 80 80","style":{"enableBackground":"new 24 -24 80 80"},"xmlSpace":"preserve"};

module.exports = Function;

Function.default = Function;
